module.exports = __webpack_public_path__ + "img/lite-unlock.04b39b14.png";